import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import SriLanka from './pages/SriLanka';
import TourPackages from './pages/TourPackages';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';
import AyurvedaPage from './pages/AyurvedaPage';
import DivingPage from './pages/DivingPage';
import ElephantRidePage from './pages/ElephantRidePage';
import FishingPage from './pages/FishingPage';
import BallooningPage from './pages/BallooningPage';
import JeepSafariPage from './pages/JeepSafariPage';
import WhiteWaterRaftingPage from './pages/WhiteWaterRaftingPage';
import RiverSafariPage from './pages/RiverSafariPage';
import SnorkelingPage from './pages/SnorkelingPage';
import TeaTastingPage from './pages/TeaTastingPage';
import TempleVisitPage from './pages/TempleVisitPage';
import WildlifeSafariPage from './pages/WildlifeSafariPage';
import WhatsApp from './components/WhatsApp';
import Facebook from './components/Facebook';
import Instagram from './components/Instagram';
import Gallery from './pages/Gallery';
import Events from './pages/Events';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Aamy Tours Sri Lanka - Discover the Pearl of the Indian Ocean"
                  description="Experience the best of Sri Lanka with Aamy Tours Sri Lanka – stunning beaches, wildlife safaris, cultural heritage, and unforgettable adventures!"
                  keywords="Aamy Tours Sri Lanka, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Wildlife Safari, Beach Holidays, Cultural Tours"
                  url="https://aamytours.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Aamy Tours Sri Lanka"
                  description="Discover Aamy Tours Sri Lanka – your trusted local travel partner offering authentic, personalized, and memorable experiences across Sri Lanka."
                  keywords="Aamy Tours Sri Lanka, About Aamy Tours, Sri Lanka Travel Agency, Local Tour Operator, Sri Lanka Holidays"
                  url="https://aamytours.com/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Aamy Tours Sri Lanka"
                  description="Let Aamy Tours Sri Lanka take you on a journey through ancient cities, lush tea plantations, pristine beaches, and thrilling wildlife safaris."
                  keywords="Explore Sri Lanka, Aamy Tours Sri Lanka, Sri Lanka Travel Guide, Best Places in Sri Lanka"
                  url="https://aamytours.com/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Aamy Tours Sri Lanka"
                  description="Handcrafted Sri Lanka tour packages by Aamy Tours – from family holidays to adventure trips and luxury getaways."
                  keywords="Sri Lanka Tour Packages, Aamy Tours Sri Lanka, Holiday Packages, Custom Tours Sri Lanka"
                  url="https://aamytours.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Aamy Tours Sri Lanka"
                  description="Beautiful moments captured on Aamy Tours Sri Lanka journeys – beaches, wildlife, temples, and happy travelers."
                  keywords="Aamy Tours Gallery, Sri Lanka Travel Photos, Tour Memories, Sri Lanka Photography"
                  url="https://aamytours.com/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/events"
            element={
              <>
                <SEO
                  title="Events & Festivals - Aamy Tours Sri Lanka"
                  description="Join Aamy Tours Sri Lanka during vibrant local festivals, cultural celebrations, and special events throughout the year."
                  keywords="Sri Lanka Events, Festivals in Sri Lanka, Aamy Tours Events, Cultural Experiences"
                  url="https://aamytours.com/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things To Do - Aamy Tours Sri Lanka"
                  description="Exciting activities in Sri Lanka with Aamy Tours – safaris, diving, rafting, balloon rides, temple visits, and more!"
                  keywords="Things to do in Sri Lanka, Aamy Tours Activities, Adventure Sri Lanka, Experiences"
                  url="https://aamytours.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Aamy Tours Sri Lanka"
                  description="Easy and secure booking with Aamy Tours Sri Lanka. Plan your perfect Sri Lankan holiday today!"
                  keywords="Book Sri Lanka Tour, Aamy Tours Booking, Reserve Holiday, Sri Lanka Travel"
                  url="https://aamytours.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Aamy Tours Sri Lanka"
                  description="Get in touch with Aamy Tours Sri Lanka team. We’re here 24/7 via phone, WhatsApp, or email to help plan your trip."
                  keywords="Contact Aamy Tours, Sri Lanka Tour Contact, Travel Inquiry, Customer Support"
                  url="https://aamytours.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />

          {/* Things To Do Individual Pages */}
          <Route
            path="/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda & Wellness - Aamy Tours Sri Lanka"
                  description="Rejuvenate with authentic Ayurvedic treatments and wellness retreats arranged by Aamy Tours Sri Lanka."
                  keywords="Ayurveda Sri Lanka, Aamy Tours Wellness, Traditional Healing, Spa Retreat"
                  url="https://aamytours.com/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/diving"
            element={
              <>
                <SEO
                  title="Scuba Diving - Aamy Tours Sri Lanka"
                  description="Dive into Sri Lanka’s underwater wonders with professional diving trips organized by Aamy Tours."
                  keywords="Diving Sri Lanka, Aamy Tours Diving, Scuba Adventures, Coral Reefs"
                  url="https://aamytours.com/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Aamy Tours Sri Lanka"
                  description="Ethical elephant encounters and sanctuary visits with Aamy Tours Sri Lanka."
                  keywords="Elephant Safari Sri Lanka, Aamy Tours, Ethical Elephant Experience"
                  url="https://aamytours.com/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Aamy Tours Sri Lanka"
                  description="Deep-sea and coastal fishing adventures in Sri Lanka with Aamy Tours."
                  keywords="Fishing Sri Lanka, Aamy Tours Fishing, Deep Sea Fishing"
                  url="https://aamytours.com/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Aamy Tours Sri Lanka"
                  description="Fly over Sri Lanka’s stunning landscapes in a hot air balloon with Aamy Tours."
                  keywords="Hot Air Balloon Sri Lanka, Aamy Tours Ballooning, Dambulla Balloon Ride"
                  url="https://aamytours.com/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Aamy Tours Sri Lanka"
                  description="Thrilling jeep safaris in Yala, Udawalawe, and Minneriya with expert guides from Aamy Tours."
                  keywords="Jeep Safari Sri Lanka, Aamy Tours Safari, Yala National Park"
                  url="https://aamytours.com/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Aamy Tours Sri Lanka"
                  description="Adrenaline-pumping white water rafting in Kitulgala with Aamy Tours Sri Lanka."
                  keywords="White Water Rafting Sri Lanka, Kitulgala Rafting, Aamy Tours Adventure"
                  url="https://aamytours.com/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Aamy Tours Sri Lanka"
                  description="Peaceful river safaris and birdwatching tours with Aamy Tours Sri Lanka."
                  keywords="River Safari Sri Lanka, Aamy Tours, Boat Safari, Nature Tour"
                  url="https://aamytours.com/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling - Aamy Tours Sri Lanka"
                  description="Explore colorful coral reefs and marine life with snorkeling trips by Aamy Tours."
                  keywords="Snorkeling Sri Lanka, Aamy Tours Snorkeling, Hikkaduwa, Pigeon Island"
                  url="https://aamytours.com/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/tea-tasting"
            element={
              <>
                <SEO
                  title="Tea Tasting & Factory Tours - Aamy Tours Sri Lanka"
                  description="Experience world-famous Ceylon tea with exclusive plantation visits and tastings by Aamy Tours."
                  keywords="Tea Tasting Sri Lanka, Aamy Tours, Ceylon Tea, Nuwara Eliya Tea Tour"
                  url="https://aamytours.com/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Aamy Tours Sri Lanka"
                  description="Spiritual journeys to Sri Lanka’s most sacred Buddhist temples with Aamy Tours."
                  keywords="Temple Tours Sri Lanka, Aamy Tours, Kandy Temple, Dambulla Cave Temple"
                  url="https://aamytours.com/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Aamy Tours Sri Lanka"
                  description="Unforgettable wildlife safaris in Sri Lanka’s top national parks with Aamy Tours Sri Lanka."
                  keywords="Wildlife Safari Sri Lanka, Aamy Tours Safari, Leopard Safari, Elephant Gathering"
                  url="https://aamytours.com/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />
        </Routes>
      </main>
      <WhatsApp />
      <Facebook />
      <Instagram />
      <Footer />
    </Router>
  );
};

export default App;